<button type="button"
        class="notification-trigger"
        [class.has-new-notification]="unopenedCount > 0"
        (click)="openRecent($event, recentPanel)"
        pTooltip="Notificaciones"
        tooltipPosition="bottom"
        [attr.aria-label]="'Abrir notificaciones. ' + unopenedCount + ' sin abrir'">
    <i class="pi pi-bell"></i>
    <span *ngIf="unopenedCount > 0" class="notification-badge">{{ badgeText }}</span>
</button>

<p-overlayPanel #recentPanel styleClass="notification-overlay" [appendTo]="'body'">
    <div class="notification-panel">
        <div class="notification-panel-header">
            <strong>Notificaciones</strong>
            <span>Últimas {{ recentPageSize }}</span>
        </div>

        <div *ngIf="loadingRecent" class="notification-state">
            <i class="pi pi-spin pi-spinner"></i>
            <span>Cargando...</span>
        </div>

        <div *ngIf="!loadingRecent && !recentNotifications.length" class="notification-state">
            <i class="pi pi-inbox"></i>
            <span>No hay notificaciones.</span>
        </div>

        <div *ngIf="!loadingRecent && recentNotifications.length" class="notification-list">
            <button type="button"
                    *ngFor="let notification of recentNotifications; trackBy: trackByNotificationId"
                    class="notification-item notification-item-compact"
                    [class.not-opened]="!notification.abierto"
                    (click)="markAsOpened(notification)">
                <div class="notification-item-icon">
                    <i [class]="notificationIcon(notification.codigo)"></i>
                </div>
                <div class="notification-item-content">
                    <div class="notification-title-row">
                        <div class="notification-title">{{ notificationShortTitle(notification) }}</div>
                    </div>
                    <div class="notification-message-top-10">{{ notification.mensaje }}</div>
                    <div class="notification-order-number">
                        {{ notification.createdOn | date:'dd/MM/yyyy HH:mm' }}
                    </div>
                </div>
            </button>
        </div>

        <button type="button" class="history-button" (click)="openHistory(recentPanel)">
            Ver historial completo
            <i class="pi pi-arrow-right"></i>
        </button>
    </div>
</p-overlayPanel>

<p-dialog header="Historial de notificaciones"
          [(visible)]="historyVisible"
          [modal]="true"
          [draggable]="false"
          [resizable]="false"
          [appendTo]="'body'"
          [style]="{width: '680px'}"
          [breakpoints]="{'768px': '95vw'}">
    <div class="history-filters">
        <div class="history-filter-field">
            <label for="notificationDateFrom">Desde</label>
            <p-calendar inputId="notificationDateFrom"
                        [(ngModel)]="historyDateFrom"
                        [locale]="listas.calendarEs"
                        [showIcon]="true"
                        [showButtonBar]="true"
                        [maxDate]="historyDateTo"
                        appendTo="body"
                        dateFormat="dd/mm/yy"
                        placeholder="dd/mm/aaaa">
            </p-calendar>
        </div>
        <div class="history-filter-field">
            <label for="notificationDateTo">Hasta</label>
            <p-calendar inputId="notificationDateTo"
                        [(ngModel)]="historyDateTo"
                        [locale]="listas.calendarEs"
                        [showIcon]="true"
                        [showButtonBar]="true"
                        [minDate]="historyDateFrom"
                        appendTo="body"
                        dateFormat="dd/mm/yy"
                        placeholder="dd/mm/aaaa">
            </p-calendar>
        </div>
        <div class="history-filter-actions">
            <button type="button"
                    pButton
                    icon="pi pi-search"
                    label="Filtrar"
                    (click)="applyHistoryFilters()">
            </button>
            <button type="button"
                    pButton
                    icon="pi pi-times"
                    class="p-button-outlined p-button-secondary"
                    pTooltip="Limpiar fechas"
                    (click)="clearHistoryFilters()">
            </button>
        </div>
    </div>

    <div *ngIf="!loadingHistory" class="history-results-summary">
        {{ historyTotal }} {{ historyTotal === 1 ? 'notificación' : 'notificaciones' }}
    </div>

    <div *ngIf="loadingHistory" class="notification-state history-state">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Cargando historial...</span>
    </div>

    <div *ngIf="!loadingHistory && !historyNotifications.length" class="notification-state history-state">
        <i class="pi pi-inbox"></i>
        <span>No hay notificaciones.</span>
    </div>

    <div *ngIf="!loadingHistory && historyNotifications.length" class="notification-list history-list">
        <button type="button"
                *ngFor="let notification of historyNotifications; trackBy: trackByNotificationId"
                class="notification-item"
                [class.not-opened]="!notification.abierto"
                (click)="markAsOpened(notification)">
            <div class="notification-item-icon">
                <i [class]="notificationIcon(notification.codigo)"></i>
            </div>
            <div class="notification-item-content">
                <div class="notification-title-row">
                    <div class="notification-title">{{ notificationShortTitle(notification) }}</div>
                </div>
                <div class="notification-message">{{ notification.mensaje }}</div>
                <div class="notification-meta">
                    {{ notification.createdOn | date:'dd/MM/yyyy HH:mm' }}
                </div>
            </div>
        </button>
    </div>

    <p-paginator *ngIf="historyTotal > historyPageSize"
                 [first]="historyPage * historyPageSize"
                 [rows]="historyPageSize"
                 [totalRecords]="historyTotal"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="{first} - {last} de {totalRecords}"
                 (onPageChange)="onHistoryPageChange($event)">
    </p-paginator>
</p-dialog>
